import useGet from "../useGet";
import moment from "moment";
import { UninvoicedItem } from "../../containers/NewOrderContainer/types";

export default (
  page: number,
  rowsPerPage: number,
  sortBy?: number,
  sortDirection?: number,
  dependencies?: any[]
) => {
  let path = `/api/Orders?status=Processed&page=${page}&page-size=${rowsPerPage}&ts=${new Date().getTime()}`;
  if (sortBy !== null && sortDirection !== null) {
    path = `/api/Orders?status=Processed&page=${page}&page-size=${rowsPerPage}&sort-by=${sortBy}&sort-direction=${sortDirection}&ts=${new Date().getTime()}`;
  }
  const { value, loading } = useGet(
    path,
    "Unable to read uninvoiced items",
    [],
    dependencies
  );

  return {
    uninvoicedItems:
      value.results &&
      value.results.map(
        (item: any) =>
          ({
            id: item.id,
            type: item.type,
            branch: item.branch,
            currencyRegion: item.currencyRegion,
            currencyName: item.currencyName,
            currencyAmount: item.currencyAmount,
            comments: item.comments,
            dateOrdered: moment(item.dateOrdered).format("DD/MM/YYYY"),
            dateRequired: moment(item.dateRequired).format("DD/MM/YYYY")
          } as UninvoicedItem)
      ),
    uninvoicedItemsLoading: loading,
    uninvoicedCurrentPage: value.currentPage,
    uninvoicedTotalCount: value.totalCount
  };
};
